import { config } from "../env";

export const formatText = (str: string) => {
  if (str) {
    const arr = str.split("_");
    const result = [];
    for (const word of arr) {
      result.push(
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // 👈️ lowercase remainder
      );
    }
    return result.join(" ");
  } else {
    return str;
  }
};

export const formatDecimal = (value: any) => {
  if (value) {
    return value ? parseFloat(value).toFixed(2) : value;
  } else {
    return value;
  }
};
export async function getHmac(message: any, secretKey: any) {
  // Convert the message and secretKey to Uint8Array
  const encoder = new TextEncoder();
  const messageUint8Array = encoder.encode(message);
  const keyUint8Array = encoder.encode(secretKey);

  // Import the secretKey as a CryptoKey
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyUint8Array,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  // Sign the message with HMAC and the CryptoKey
  const signature = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    messageUint8Array
  );

  // Convert the signature ArrayBuffer to a hex string
  const hashArray = Array.from(new Uint8Array(signature));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hashHex;
}

export async function aesGcmEncrypt(plaintext: string) {
  const pwUtf8 = new TextEncoder().encode(config.AUTH_SHARED_KEY); // encode secretKey as UTF-8
  const pwHash = await crypto.subtle.digest("SHA-256", pwUtf8); // hash the secretKey

  const iv = crypto.getRandomValues(new Uint8Array(12)); // get 96-bit random iv
  const ivStr = Array.from(iv)
    .map((b) => String.fromCharCode(b))
    .join(""); // iv as utf-8 string

  const alg = { name: "AES-GCM", iv: iv }; // specify algorithm to use

  const key = await window.crypto.subtle.importKey("raw", pwHash, alg, false, [
    "encrypt",
  ]); // generate key from pw

  const ptUint8 = new TextEncoder().encode(plaintext); // encode plaintext as UTF-8
  const ctBuffer = await window.crypto.subtle.encrypt(alg, key, ptUint8); // encrypt plaintext using key

  const ctArray = Array.from(new Uint8Array(ctBuffer)); // ciphertext as byte array
  const ctStr = ctArray.map((byte) => String.fromCharCode(byte)).join(""); // ciphertext as string
  return btoa(ivStr + ctStr); // iv+ciphertext base64-encoded
}

// export const getEncodedKey = (url: string) => {
//   return btoa(decodeURIComponent(new URL(url).pathname.replace("/", "")));
// };

function isValidURL(url: string) {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
}

export const getEncodedKey = (keyOrUrl: string) => {
  if (isValidURL(keyOrUrl)) {
    return btoa(
      decodeURIComponent(new URL(keyOrUrl).pathname.replace("/", ""))
    );
  } else {
    return btoa(decodeURIComponent(keyOrUrl));
  }
};

export const numberFormatter = (num: any) => {
  return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export function debounceSearch<F extends (...args: any[]) => void>(
  func: F,
  delay: number
): (...args: Parameters<F>) => void {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<F>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
